// outputs/active-adapter-proposal-2026-10-21/src/tcou-purchase-resolver.mjs
var TAG = "TCOU888-20";
function amazonDestination(raw) {
  if (typeof raw !== "string" || !raw || raw !== raw.trim() || /[^\x21-\x7e]|\\/.test(raw)) return null;
  if (!/^https:\/\/(?:www\.)?amazon\.com\/dp\/[A-Z0-9]{10}\/?(?:\?[^#]*)?$/.test(raw)) return null;
  try {
    const u = new URL(raw);
    if (u.protocol !== "https:" || !["amazon.com", "www.amazon.com"].includes(u.hostname) || u.username || u.password || u.port || u.hash || !/^\/dp\/[A-Z0-9]{10}\/?$/.test(u.pathname)) return null;
    const pairs = [...u.searchParams];
    if (new Set(pairs.map((x) => x[0])).size !== pairs.length || pairs.some(([k, v]) => !["language", "th", "psc", "tag"].includes(k) || !v)) return null;
    const tag = u.searchParams.get("tag");
    if (tag && tag !== TAG) return null;
    if (!tag) u.searchParams.set("tag", TAG);
    return tag ? raw : u.href;
  } catch {
    return null;
  }
}

// outputs/active-adapter-proposal-2026-10-21/src/tcou-storefront-components.mjs
function createCrossSellController({ loadCurrentProduct, addVariant, readCart, onCart }) {
  let busy = false;
  return { get busy() {
    return busy;
  }, async add(productId, variantId) {
    if (busy) return { accepted: false, reason: "busy" };
    busy = true;
    let attempted = false;
    try {
      const p = await loadCurrentProduct(productId);
      const v = p?.variants?.find((v2) => v2.id === variantId);
      if (p?.id !== productId || p.mode !== "Shopify" || p.approved !== true || p.externalEvidence === true || !v || v.available !== true || v.decision?.local_allowed !== true)
        return { accepted: false, reason: "not_current_approved_ordinary" };
      attempted = true;
      await addVariant({ id: variantId, quantity: 1 });
      return { accepted: true, variantId, sku: v.sku, price: v.price };
    } finally {
      try {
        if (attempted) onCart(await readCart());
      } finally {
        busy = false;
      }
    }
  } };
}
function mountCrossSell(root, products, controller) {
  const doc = root.ownerDocument;
  root.replaceChildren();
  for (const p of products) {
    let selected = function() {
      return p.variants.find((v) => v.id === select.value);
    }, update = function() {
      const v = selected();
      details.textContent = v ? (v.priceDisplay || "Price unavailable") : "Choose an option";
      button.disabled = p.approved !== true || v?.available !== true || v?.decision?.local_allowed !== true;
    };
    if (p.mode !== "Shopify" || p.externalEvidence === true) continue;
    const box = doc.createElement("article");
    box.className = "tcou-find";
    const h = doc.createElement("h3");
    h.textContent = p.title;
    if (typeof p.image === "string" && /^(https:\/\/|\/\/)/.test(p.image)) {
      const image = doc.createElement("img"); image.src = p.image; image.alt = p.imageAlt || p.title; image.loading = "lazy"; image.width = 240; image.height = 240; box.append(image);
    }
    if (typeof p.url === "string" && p.url.startsWith("/") && !p.url.startsWith("//")) { const link = doc.createElement("a"); link.href = p.url; link.append(h); box.append(link); } else box.append(h);
    const select = doc.createElement("select");
    select.setAttribute("aria-label", p.title + " variant");
    for (const v of p.variants) {
      const o = doc.createElement("option");
      o.value = v.id;
      o.textContent = v.title;
      select.append(o);
    }
    const details = doc.createElement("p");
    details.setAttribute("aria-live", "polite");
    const status = doc.createElement("p");
    status.setAttribute("role", "status");
    const button = doc.createElement("button");
    button.type = "button";
    button.className = "btn btn--secondary";
    button.textContent = "Add selected option";
    select.addEventListener("change", update);
    button.addEventListener("click", async () => {
      button.disabled = true;
      status.textContent = "Updating cart\u2026";
      try {
        const result = await controller.add(p.id, select.value);
        status.textContent = result.accepted ? "Selected option added; cart refreshed." : "Item unavailable for this offer.";
      } catch {
        status.textContent = "Could not confirm addition. Check the refreshed cart before retrying.";
      } finally {
        update();
      }
    });
    box.append(select, details, button, status);
    update();
    root.append(box);
  }
}

// outputs/active-adapter-proposal-2026-10-21/src/tcou-cart-integration.mjs
function ajaxVariantId(gid) {
  if (typeof gid === "number" && !Number.isSafeInteger(gid)) throw Error("Unsafe numeric identity");
  const value = String(gid).replace(/^gid:\/\/shopify\/ProductVariant\//, "");
  if (!/^[1-9][0-9]*$/.test(value)) throw Error("Invalid variant identity");
  return value;
}
function quantity(value, allowZero = false) {
  if (!Number.isSafeInteger(value) || value < (allowZero ? 0 : 1)) throw Error("Invalid quantity");
  return value;
}
function createAjaxCartTransport({ fetchImpl, root = "/", writesEnabled = false }) {
  if (!/^\/(?:[A-Za-z0-9_-]+\/)*$/.test(root)) throw Error("Use a relative localized storefront root");
  async function request(path, body) {
    if (body && !writesEnabled) throw Error("Live cart writes are disabled");
    const response = await fetchImpl(root + path, {
      method: body ? "POST" : "GET",
      credentials: "same-origin",
      cache: "no-store",
      headers: { Accept: "application/json", ...body ? { "Content-Type": "application/json" } : {} },
      ...body ? { body: JSON.stringify(body) } : {}
    });
    let result;
    try {
      result = await response.json();
    } catch {
      throw Error("Unreadable cart response; refresh required");
    }
    if (!response.ok) {
      const error = Error(result.description || result.message || "Cart request failed");
      error.status = response.status;
      error.cartResponse = result;
      throw error;
    }
    return result;
  }
  return {
    read: () => request("cart.js"),
    add: ({ id, quantity: q }) => request("cart/add.js", { items: [{ id: ajaxVariantId(id), quantity: quantity(q) }] }),
    change: ({ key, quantity: q }) => {
      if (typeof key !== "string" || !key) throw Error("Exact cart line key required");
      return request("cart/change.js", { id: key, quantity: quantity(q, true) });
    }
  };
}
function createOrdinaryCartIntegration({ transport, loadCurrentProduct, approvedProductIDs, onCart }) {
  const allowlist = new Set(approvedProductIDs);
  let selectedQuantity = 1, lastCart = null, refreshRequired = false, mutationAttempted = false, working = false;
  async function refresh() {
    const cart = await transport.read();
    if (!cart || !Array.isArray(cart.items) || !Number.isSafeInteger(cart.item_count) || typeof cart.total_price !== "number")
      throw Error("Invalid server cart; do not display estimated totals");
    lastCart = cart;
    await onCart(cart);
    refreshRequired = false;
    return cart;
  }
  async function load(id) {
    if (!allowlist.has(id)) return null;
    const p = await loadCurrentProduct(id);
    return p?.id === id && p.mode === "Shopify" && p.approved === true && p.externalEvidence === false ? p : null;
  }
  const base = createCrossSellController({
    loadCurrentProduct: load,
    addVariant: async (item) => {
      mutationAttempted = true;
      return transport.add({ ...item, quantity: selectedQuantity });
    },
    readCart: async () => {
      try {
        return await refresh();
      } catch (error) {
        refreshRequired = true;
        throw error;
      }
    },
    onCart: () => {
    }
  });
  return {
    get cart() {
      return lastCart;
    },
    get busy() {
      return working || base.busy;
    },
    get refreshRequired() {
      return refreshRequired;
    },
    async recover() {
      if (working) throw Error("Cart request in progress");
      working = true;
      try {
        return await refresh();
      } catch (error) {
        refreshRequired = true;
        throw error;
      } finally {
        working = false;
      }
    },
    async add(productId, variantId, q = 1) {
      if (working || base.busy) return { accepted: false, reason: "busy" };
      if (refreshRequired) return { accepted: false, reason: "refresh_required" };
      quantity(q);
      selectedQuantity = q;
      mutationAttempted = false;
      working = true;
      try {
        return await base.add(productId, variantId);
      } catch (error) {
        return {
          accepted: false,
          reason: "request_not_confirmed",
          message: error.message,
          mutationMayHaveOccurred: mutationAttempted,
          cart: lastCart,
          refreshRequired
        };
      } finally {
        working = false;
      }
    },
    async change(lineKey, q) {
      quantity(q, true);
      if (working || base.busy) return { accepted: false, reason: "busy" };
      if (refreshRequired) return { accepted: false, reason: "refresh_required" };
      working = true;
      let attempted = false;
      try {
        const cart = await refresh();
        const line = cart.items.find((x) => x.key === lineKey);
        if (!line) return { accepted: false, reason: "line_changed" };
        if (q > 0) {
          const id = "gid://shopify/Product/" + line.product_id;
          const variant = "gid://shopify/ProductVariant/" + line.variant_id;
          const p = await load(id);
          const v = p?.variants?.find((v2) => v2.id === variant);
          if (!v || v.available !== true || v.decision?.local_allowed !== true)
            return { accepted: false, reason: "not_current_approved_ordinary" };
        }
        attempted = true;
        await transport.change({ key: lineKey, quantity: q });
        return { accepted: true };
      } catch (error) {
        return { accepted: false, reason: "change_not_confirmed", message: error.message };
      } finally {
        try {
          if (attempted) await refresh();
        } catch {
          refreshRequired = true;
          return { accepted: false, reason: "refresh_required", mutationMayHaveOccurred: true };
        } finally {
          working = false;
        }
      }
    }
  };
}
function currentOfferSelection(product, saved = null) {
  const variantId = saved ? product.variants.some((v) => v.id === saved.variantId) ? saved.variantId : "" : product.variants.find((v) => v.available === true)?.id || "";
  return { variantId, quantity: Number.isSafeInteger(saved?.quantity) && saved.quantity > 0 ? saved.quantity : 1 };
}
function mountQuantityCrossSell(root, products, integration, state = /* @__PURE__ */ new Map()) {
  const controls = /* @__PURE__ */ new Map();
  mountCrossSell(root, products, {
    get busy() {
      return integration.busy;
    },
    add: (productId, variantId) => integration.add(productId, variantId, controls.get(productId)?.valueAsNumber ?? 1)
  });
  const displayed = products.filter((p) => p.mode === "Shopify" && p.externalEvidence !== true);
  for (const [index, p] of displayed.entries()) {
    const box = root.children[index], label = root.ownerDocument.createElement("label");
    label.textContent = "Quantity";
    const input = root.ownerDocument.createElement("input");
    input.type = "number";
    input.min = "1";
    input.step = "1";
    const selection = currentOfferSelection(p, state.get(p.id));
    input.value = String(selection.quantity);
    input.setAttribute("aria-label", p.title + " offer quantity");
    label.append(input);
    box.insertBefore(label, box.querySelector("button"));
    controls.set(p.id, input);
    const select = box.querySelector("select");
    select.value = selection.variantId;
    select.dispatchEvent(new Event("change", { bubbles: true }));
    const remember = () => state.set(p.id, { variantId: select.value, quantity: input.valueAsNumber });
    select.addEventListener("change", remember);
    input.addEventListener("input", remember);
    remember();
  }
  return state;
}

// outputs/active-adapter-proposal-2026-10-21/src/tcou-integration.mjs
function parseContract(html, selector, Parser = DOMParser) {
  const doc = new Parser().parseFromString(html, "text/html");
  const node = doc.querySelector(selector);
  if (!node) throw Error("Missing authoritative theme contract");
  return JSON.parse(node.textContent);
}
function ownedFormAllowed(form) {
  const scope = form.closest("[data-tcou-purchase]");
  return !!scope && !scope.inert && scope.dataset.tcouMode === "Shopify" && String(form.querySelector('[name="id"]')?.value || "") === String(scope.dataset.tcouVariant || "") && !!scope.dataset.tcouVariant;
}
function contractURL(root, path, section) {
  const url = new URL(path, location.origin);
  if (url.origin !== location.origin) throw Error("Cross-origin contract");
  if (!url.pathname.startsWith(root)) throw Error("Non-localized contract");
  url.searchParams.set("section_id", section);
  return url;
}
async function fetchContract(url, selector, { timeoutMs = 0 } = {}) {
  const controller = timeoutMs > 0 ? new AbortController() : null;
  let timer;
  const read = async () => {
    const r = await fetch(url, { credentials: "same-origin", cache: "no-store", headers: { Accept: "text/html" }, ...(controller ? { signal: controller.signal } : {}) });
    if (!r.ok) throw Error("Contract unavailable");
    return parseContract(await r.text(), selector);
  };
  try {
    return controller ? await Promise.race([read(), new Promise((_, reject) => {
      timer = setTimeout(() => { controller.abort(); reject(Error("Product classification timed out")); }, timeoutMs);
    })]) : await read();
  } finally { clearTimeout(timer); }
}
function createProductContractReader(read) {
  const pendingDiscovery = new Map();
  return (url, { discovery = false } = {}) => {
    // A purchase-time read must never join a discovery read or use cached approval.
    if (!discovery) return Promise.resolve().then(() => read(url));
    const key = String(url);
    if (pendingDiscovery.has(key)) return pendingDiscovery.get(key);
    const pending = Promise.resolve().then(() => read(url)).finally(() => {
      if (pendingDiscovery.get(key) === pending) pendingDiscovery.delete(key);
    });
    pendingDiscovery.set(key, pending);
    return pending;
  };
}
// Remember cart state, not DOM identity, so native refreshes cannot replay the glow.
function createShippingCelebration(doc, storage, reducedMotion = () => false) {
  const key = "tcou-shipping-state-v1";
  let previous = null;
  try { previous = storage?.getItem(key) || null; } catch { /* Storage may be disabled. */ }
  return () => {
    const hosts = [...doc.querySelectorAll("[data-tcou-shipping-state]")];
    if (!hosts.length) { previous = "inactive"; try { storage?.setItem(key, previous); } catch { /* Storage may be disabled. */ } return; }
    const states = hosts.map(el => el.dataset.tcouShippingState);
    // Wait until supported surfaces agree during a partial native merge.
    if (new Set(states).size !== 1) return;
    const state = states[0];
    if (!["below", "qualified", "inactive"].includes(state)) return;
    const celebrate = previous === "below" && state === "qualified";
    previous = state;
    try { storage?.setItem(key, state); } catch { /* In-document tracking still works. */ }
    if (celebrate && !reducedMotion()) {
      for (const host of hosts) {
        const indicator = host.matches(".tcou-shipping-progress--qualified") ? host : host.querySelector(".tcou-shipping-progress--qualified");
        if (!indicator) continue;
        indicator.classList.add("tcou-shipping-progress--celebrate");
        indicator.addEventListener("animationend", () => indicator.classList.remove("tcou-shipping-progress--celebrate"), { once: true });
      }
    }
  };
}
// Preserve Shopify's result sequence for Symmetry's native first-cart-item seed.
function createNativeRecommendationLoader(fetchImpl, root, now = Date.now, timeoutMs = 2500) {
  const cache = new Map();
  return async cart => {
    const id = String(cart.items[0]?.product_id || "");
    if (!/^\d+$/.test(id)) return [];
    // Cart membership affects Shopify's native result eligibility.
    const key = root + ":" + id + ":" + cart.items.map(i => String(i.product_id)).join(",");
    const cached = cache.get(key);
    if (cached && cached.expires > now()) return cached.promise;
    if (cache.size >= 12) cache.delete(cache.keys().next().value);
    const entry = { expires: now() + 60000 };
    entry.promise = (async () => {
      const controller = new AbortController(); let timer;
      try {
        const request = (async () => {
          const response = await fetchImpl(root + "recommendations/products.json?product_id=" + id + "&limit=10&intent=related", { credentials: "same-origin", signal: controller.signal });
          if (!response.ok) throw Error("Recommendation unavailable");
          const data = await response.json();
          return Array.isArray(data.products) ? data.products : [];
        })();
        return await Promise.race([request, new Promise((_, reject) => { timer = setTimeout(() => { controller.abort(); reject(Error("Recommendation timeout")); }, timeoutMs); })]);
      } catch { entry.expires = now() + 5000; return []; }
      finally { clearTimeout(timer); }
    })();
    cache.set(key, entry); return entry.promise;
  };
}
function safeRecommendationPath(raw, root = "/") {
  if (typeof raw !== "string" || !raw.startsWith(root + "products/") || raw.startsWith("//") || /[\\\x00-\x20]/.test(raw)) return null;
  try { const u = new URL(raw, "https://tcou.invalid"); return u.origin === "https://tcou.invalid" && u.pathname.startsWith(root + "products/") ? u.pathname + u.search : null; } catch { return null; }
}
function recommendationDiscovery(result, root = "/") {
  const id = String(result?.id || "");
  if (!/^\d+$/.test(id)) return null;
  const fallback = typeof result.handle === "string" && !/[\/\\?#]/.test(result.handle) ? root + "products/" + encodeURIComponent(result.handle) : null;
  const url = safeRecommendationPath(result.url, root) || fallback;
  if (!url) return null;
  return { id: "gid://shopify/Product/" + id, title: result.title, url,
    image: result.featured_image || result.images?.[0] || null, imageAlt: result.title,
    mode: "Unknown", approved: false, externalEvidence: true, variants: [],
    priceDisplay: "See product for current price" };
}
function mountClassifiedRecommendations(root, products, integration, state, loadCurrentProduct) {
  const doc = root.ownerDocument; root.replaceChildren();
  for (const p of products) {
    let box;
    if (p.mode === "Shopify" && p.approved === true && p.externalEvidence === false) {
      const temporary = doc.createElement("div"); mountQuantityCrossSell(temporary, [p], integration, state); box = temporary.firstElementChild;
      const select = box.querySelector("select"), button = box.querySelector("button");
      const update = () => { const v = p.variants.find(v => v.id === select.value); button.textContent = v?.available === false || p.variants.every(v => !v.available) ? "SOLD OUT" : "Add selected option"; };
      select.addEventListener("change", update); update();
    } else {
      box = doc.createElement("article"); box.className = "tcou-find";
      if (typeof p.image === "string" && /^(https:\/\/|\/\/)/.test(p.image)) { const image = doc.createElement("img"); image.src = p.image; image.alt = p.imageAlt || p.title; image.loading = "lazy"; image.width = 240; image.height = 240; box.append(image); }
      const heading = doc.createElement("h3"), link = doc.createElement("a"); heading.textContent = p.title; link.href = p.url; link.append(heading); box.append(link);
      const price = doc.createElement("p"); price.textContent = p.variants[0]?.priceDisplay || p.priceDisplay || "See product for current price"; box.append(price);
      if (p.mode === "Amazon") {
        const select = doc.createElement("select"); select.setAttribute("aria-label", p.title + " variant");
        for (const v of p.variants) { const option = doc.createElement("option"); option.value = v.id; option.textContent = v.title; select.append(option); }
        select.value = currentOfferSelection(p, state.get(p.id)).variantId; box.append(select);
        const action = doc.createElement("a"); action.className = "btn btn--secondary"; action.rel = "sponsored noopener";
        const status = doc.createElement("p"); status.setAttribute("role", "status");
        const update = () => {
          const v = p.variants.find(v => v.id === select.value), url = v?.mode === "Amazon" ? amazonDestination(v.externalUrl) : null;
          price.textContent = v?.priceDisplay || "See product for current price";
          const ready = v?.available === true && !!url;
          action.textContent = v?.available === false || p.variants.every(v => !v.available) ? "SOLD OUT" : "Buy on Amazon";
          action.setAttribute("aria-disabled", String(!ready)); if (ready) action.href = url; else action.removeAttribute("href");
          state.set(p.id, { variantId: select.value, quantity: 1 });
        };
        select.addEventListener("change", update); update();
        action.addEventListener("click", async event => {
          event.preventDefault(); if (action.getAttribute("aria-disabled") === "true") return;
          const selectedId = select.value; action.setAttribute("aria-busy", "true");
          try {
            const live = await loadCurrentProduct(p.id), v = live?.variants.find(v => v.id === selectedId);
            const url = live?.mode === "Amazon" && v?.mode === "Amazon" && v.available === true ? amazonDestination(v.externalUrl) : null;
            if (!url || select.value !== selectedId || !box.isConnected) throw Error("Destination changed");
            window.location.assign(url);
          } catch { action.removeAttribute("href"); action.setAttribute("aria-disabled", "true"); status.textContent = "Purchase link could not be confirmed. View the product for current options."; }
          finally { action.removeAttribute("aria-busy"); }
        });
        box.append(action); const disclosure = doc.createElement("p"); disclosure.textContent = "As an Amazon Associate, TCoU earns from qualifying purchases."; box.append(disclosure, status);
      }
      const view = doc.createElement("a"); view.className = "btn btn--secondary"; view.href = p.url; view.textContent = "View Product"; box.append(view);
    }
    const label = doc.createElement("p"); label.textContent = p.mode === "Shopify" ? "Purchase at TCoU" : p.mode === "Amazon" ? "Amazon affiliate" : "Purchasing restricted — view product";
    box.querySelector("h3")?.closest("a")?.after(label);
    box.dataset.tcouOfferId = p.id; box.dataset.tcouOfferMode = p.mode;
    root.append(box);
  }
}
function boot(doc = document) {
  const root = window.Shopify?.routes?.root;
  if (!/^\/(?:[A-Za-z0-9_-]+\/)*$/.test(root || "")) return;
  const cartURL = root + "cart";
  const sectionFor = (e) => e.closest(".shopify-section") || e;
  const pending = /* @__PURE__ */ new WeakMap(), consented = /* @__PURE__ */ new WeakSet(), mounts = /* @__PURE__ */ new WeakSet(), offerLoads = new WeakMap(), saved = /* @__PURE__ */ new Map();
  function setPending(section, busy, failed = false) {
    section.querySelectorAll("[data-tcou-purchase],[data-tcou-sticky]").forEach((el) => {
      el.inert = busy;
      el.toggleAttribute("inert", busy);
      el.setAttribute("aria-busy", String(busy));
    });
    let status = section.querySelector("[data-tcou-variant-status]");
    if (!status) {
      status = doc.createElement("p");
      status.dataset.tcouVariantStatus = "";
      status.setAttribute("role", "status");
      section.querySelector(".product-form")?.append(status);
    }
    if (status) status.textContent = failed ? "Unable to confirm this option. Refresh before purchasing." : busy ? "Checking selected option\xC3\u0192\xC6\u2019\xC3\u201A\xC2\xA2\xC3\u0192\xC2\xA2\xC3\xA2\xE2\u201A\xAC\xC5\xA1\xC3\u201A\xC2\xAC\xC3\u0192\xE2\u20AC\u0161\xC3\u201A\xC2\xA6" : "";
  }
  doc.addEventListener("tcou:variant-pending", (e) => {
    const section = sectionFor(e.target);
    pending.set(section, { token: e.detail?.token, busy: true });
    setPending(section, true);
  });
  doc.addEventListener("tcou:variant-settled", (e) => {
    const section = sectionFor(e.target);
    if (pending.get(section)?.token !== e.detail?.token) return;
    pending.set(section, { token: e.detail?.token, busy: !e.detail?.applied });
    setPending(section, !e.detail?.applied, !e.detail?.applied);
    updateSticky();
  });
  doc.addEventListener("click", (e) => {
    const a = e.target.closest("a");
    if (!a) return;
    if (a.closest("[data-tcou-purchase],[data-tcou-sticky]")) {
      if (pending.get(sectionFor(a))?.busy || a.closest("[inert]")) {
        e.preventDefault();
        return;
      }
      if (a.matches(".tcou-amazon-link") && !amazonDestination(a.href)) e.preventDefault();
    }
    const line = a.closest("[data-tcou-line-mode]");
    if (line && line.dataset.tcouLineMode !== "Shopify" && a.matches(".quantity-up")) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);
  doc.addEventListener("change", (e) => {
    const line = e.target.closest("[data-tcou-line-mode]");
    if (line && line.dataset.tcouLineMode !== "Shopify" && e.target.matches(".cart-item__quantity-input") && Number(e.target.value) > Number(line.dataset.tcouLineQuantity)) {
      e.target.value = line.dataset.tcouLineQuantity;
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);
  const termsAccepted = (surface) => [...surface.querySelectorAll("terms-agreement")].every((el) => !!el.querySelector("input:checked"));
  const freshCart = async () => {
    const c = await fetchContract(contractURL(root, root, "tcou-cart-contract"), "[data-tcou-cart-contract]");
    if (c.version !== "tcou-cart-1" || typeof c.allowed !== "boolean" || !Array.isArray(c.items) || c.items.some((i) => !/^([1-9][0-9]*)$/.test(i.product_id) || !/^([1-9][0-9]*)$/.test(i.variant_id) || !Number.isSafeInteger(i.quantity) || i.quantity < 1 || typeof i.key !== "string" || !i.key)) throw Error("Invalid cart contract");
    return c;
  };
  doc.addEventListener("submit", (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    let action;
    try {
      action = new URL(form.action, location.href);
    } catch {
      return;
    }
    if (action.origin === location.origin && /\/cart\/add(?:\.js)?\/?$/.test(action.pathname)) {
      if (!ownedFormAllowed(form)) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
      return;
    }
    if (e.submitter?.name !== "checkout" || !form.closest("[data-tcou-cart-surface]")) return;
    if (consented.has(form)) {
      consented.delete(form);
      return;
    }
    if (!termsAccepted(form.closest("[data-tcou-cart-surface]"))) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showCartError(form, "Please accept the store terms before continuing.");
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    const button = e.submitter;
    button.disabled = true;
    freshCart().then((c) => {
      if (c.allowed !== true || !termsAccepted(form.closest("[data-tcou-cart-surface]"))) throw Error("Cart or terms changed");
      if (!form.checkValidity()) {
        button.disabled = false;
        form.reportValidity();
        return;
      }
      consented.add(form);
      button.disabled = false;
      form.requestSubmit(button);
    }).catch(() => {
      button.disabled = false;
      showCartError(form);
    });
  }, true);
  doc.addEventListener("click", (e) => {
    const a = e.target.closest("[data-tcou-cart-surface] .checkout-buttons a");
    if (!a || a.hasAttribute("data-tcou-cart-recovery")) return;
    if (new URL(a.href).pathname === new URL(cartURL, location.origin).pathname) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!termsAccepted(a.closest("[data-tcou-cart-surface]"))) {
      showCartError(a, "Please accept the store terms before continuing.");
      return;
    }
    if (a.getAttribute("aria-busy") === "true") return;
    a.setAttribute("aria-busy", "true");
    freshCart().then((c) => {
      if (c.allowed !== true || !termsAccepted(a.closest("[data-tcou-cart-surface]"))) throw Error("Restricted cart or terms");
      location.assign(a.href);
    }).catch(() => showCartError(a)).finally(() => a.removeAttribute("aria-busy"));
  }, true);
  function showCartError(el, message = null) {
    let box = el.closest("[data-tcou-cart-surface]")?.querySelector("[data-tcou-checkout-error]");
    if (!box) {
      box = doc.createElement("p");
      box.dataset.tcouCheckoutError = "";
      box.setAttribute("role", "alert");
      el.closest("[data-tcou-cart-surface]")?.append(box);
    }
    box.textContent = message || "Checkout could not be confirmed. Review your cart and remove items that cannot be purchased here.";
  }
  async function mergeNativeCarts() {
    const forms = [...doc.querySelectorAll("cart-form[data-tcou-cart-surface]")];
    await Promise.all(forms.map(async (form) => {
      const section = form.dataset.sectionId;
      if (!section || typeof form.refreshFromHtml !== "function") throw Error("Native cart refresh not ready");
      const r = await fetch(contractURL(root, location.pathname, section), { credentials: "same-origin", cache: "no-store" });
      if (!r.ok) throw Error("Cart view refresh failed");
      const html = await r.text();
      if (!html.includes("data-tcou-cart-surface")) throw Error("Unexpected cart section");
      form.refreshFromHtml(html);
    }));
  }
  const nativeRecommendations = createNativeRecommendationLoader(fetch, root);
  const readProductContract = createProductContractReader(url => fetchContract(url, "[data-tcou-product-contract]", { timeoutMs: 5000 }));
  async function mountOffers(widget) {
    if (mounts.has(widget)) return;
    mounts.add(widget);
    const loadToken = {}; offerLoads.set(widget, loadToken);
    const status = widget.querySelector("[data-tcou-offer-status]"), list = widget.querySelector("[data-tcou-offer-list]");
    const paths = new Map();
    async function load(id, knownCart = null) {
      const path = paths.get(id); if (!path) return null;
      const cart = knownCart || await freshCart();
      if (cart.allowed !== true || cart.items.some(i => "gid://shopify/Product/" + i.product_id === id)) return null;
      const url = contractURL(root, path, "tcou-product-contract");
      // Attribution belongs to the product link, not the equivalent classification read.
      url.search = ""; url.searchParams.set("section_id", "tcou-product-contract");
      const product = await readProductContract(url, { discovery: knownCart !== null });
      return product.version === "tcou-purchase-1" && product.id === id ? product : null;
    }
    try {
      const cart = await freshCart();
      const limit = widget.dataset.tcouOfferLimit === "2" ? 2 : 3;
      // Slice only for the presentation limit. No classification filter or custom reordering.
      const results = (await nativeRecommendations(cart)).slice(0, limit);
      const products = await Promise.all(results.map(async result => {
        const discovery = recommendationDiscovery(result, root); if (!discovery) return null;
        paths.set(discovery.id, discovery.url);
        try {
          const contract = await load(discovery.id, cart);
          return contract ? { ...contract, url: discovery.url } : discovery;
        } catch { return discovery; }
      }));
      const displayProducts = products.filter(Boolean);
      if (!widget.isConnected || offerLoads.get(widget) !== loadToken) return;
      if (!displayProducts.length) {
        widget.hidden = true;
        return;
      }
      widget.hidden = false;
      const integration = createOrdinaryCartIntegration({
        transport: createAjaxCartTransport({ fetchImpl: fetch, root, writesEnabled: true }),
        loadCurrentProduct: load,
        approvedProductIDs: displayProducts.filter(p => p.mode === "Shopify" && p.approved === true && p.externalEvidence === false).map(p => p.id),
        onCart: async () => {
          await mergeNativeCarts();
          status.textContent = "Cart updated from Shopify.";
        }
      });
      mountClassifiedRecommendations(list, displayProducts, integration, saved, load);
    } catch {
      if (offerLoads.get(widget) === loadToken && widget.isConnected) status.textContent = "Recommendations are temporarily unavailable. Your cart is unchanged.";
    }
  }
  function updateSticky() {
    for (const el of doc.querySelectorAll("[data-tcou-sticky]")) {
      const section = sectionFor(el), main = section.querySelector("[data-tcou-purchase]"), r = main?.getBoundingClientRect();
      const drawerOpen = !!doc.querySelector('.js-cart-drawer[open],.js-cart-drawer[aria-hidden="false"]');
      el.hidden = !r || r.bottom > 0 || drawerOpen || !!pending.get(section)?.busy;
    }
  }
  let shippingStorage;
  try { shippingStorage = window.sessionStorage; } catch { /* Private storage may be unavailable. */ }
  const updateShippingCelebration = createShippingCelebration(doc, shippingStorage, () => window.matchMedia?.("(prefers-reduced-motion: reduce)").matches === true);
  const scan = () => {
    updateShippingCelebration();
    doc.querySelectorAll("[data-tcou-offers]").forEach(mountOffers);
    updateSticky();
  };
  const observer = new MutationObserver(() => queueMicrotask(scan));
  observer.observe(doc.body, { childList: true, subtree: true });
  doc.addEventListener("on:cart-drawer:before-open", () => doc.querySelectorAll("[data-tcou-sticky]").forEach((el) => {
    el.hidden = true;
  }));
  doc.addEventListener("on:cart-drawer:after-open", updateSticky);
  doc.addEventListener("on:cart-drawer:before-close", (event) => {
    const drawer = event.target;
    queueMicrotask(() => {
      if (!drawer.hasAttribute("open") && (doc.activeElement === doc.body || drawer.contains(doc.activeElement))) {
        doc.querySelector(".cart-link")?.focus({ preventScroll: true });
      }
    });
  });
  doc.addEventListener("on:cart-drawer:after-close", updateSticky);
  doc.addEventListener("on:cart:after-merge", () => {
    doc.querySelectorAll("[data-tcou-offers]").forEach(widget => { mounts.delete(widget); widget.querySelector("[data-tcou-offer-list]")?.replaceChildren(); });
    scan();
  });
  window.addEventListener("scroll", updateSticky, { passive: true });
  window.addEventListener("resize", updateSticky);
  scan();
  return { disconnect() {
    observer.disconnect();
    window.removeEventListener("scroll", updateSticky);
    window.removeEventListener("resize", updateSticky);
  } };
}
if (typeof document !== "undefined") {
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => boot(), { once: true });
  else boot();
}
export {
  createProductContractReader,
  createNativeRecommendationLoader,
  safeRecommendationPath,
  recommendationDiscovery,
  mountClassifiedRecommendations,
  createShippingCelebration,
  boot,
  contractURL,
  fetchContract,
  ownedFormAllowed,
  parseContract
};
